<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <onaydialog ref="onaydialog"></onaydialog>
    <loadingcomp v-bind:mesaj="''" v-model="loadingvmodel"></loadingcomp>
<v-dialog v-model="dialogsonucv2" scrollable persistent="" max-width="800px">

<v-card flat>
  <v-card-title> 
    <v-toolbar size="120px" dark color="info">
                <v-toolbar-title class="baslikfont">
                 
                  <span >
                    Credit Note Oluşturma Sonucu
                  </span> 
                
                </v-toolbar-title>
                <v-spacer></v-spacer>
                    
                       
                </v-toolbar>     
  </v-card-title>
  <v-divider></v-divider>
  <v-card-text>

    <v-card>
      <v-card flat="">
        <v-card-actions>
          <v-layout row="" wrap="">
          

         


          

            <v-flex pb-2  xs12 sm6 md12>
                <div class="green--text" v-if="CreateCreditNoteResult">
  <span  class="px-12">  {{ this.creditnotemesaj}}  </span>
                  </div>
                  <div  class="red--text" v-if="!CreateCreditNoteResult">
  <span  class="px-12">  {{ this.creditnotemesaj}}  </span>
                  </div>
               
            </v-flex>
           
            <v-divider></v-divider>


          

          
            <v-flex xs12 sm12 md12>
              <v-card flat>
                <v-data-table :headers="headerscreditnotesonuc" :rows-per-page-items=[50,100,250,500,1000] :items="creditnotesreturn" item-key="CreditNoteNumber">
                  <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{ props.item.CreditNoteNumber  }}</td>
                    <td class="text-xs-left">{{ props.item.InvoiceReference  }}</td>
                    <td v-if="props.item.success==true" class="text-xs-left"><span
                        class="green--text"> {{ $t('Successful') }} </span></td>
                    <td v-if="props.item.success==false" class="text-xs-left"><span
                        class="red--text"> {{ $t('Unsuccessful') }}  </span></td>
                    <td class="text-xs-left">{{ props.item.ErrorMessage }}</td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-card-text>
  <v-divider></v-divider>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn color="blue darken-1" flat @click.native="dialogsonuciptalv2()">Kapat</v-btn>
  </v-card-actions>
</v-card>


</v-dialog>
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ $t('Refund-List') }} </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile v-if="Rapor.DekontPusula==1" @click="secilibiletlereDekontBasdialog()">
                    <v-list-tile-title> {{ $t('Print-Receipt-for-Selected-Tickets') }} </v-list-tile-title>
                  </v-list-tile>

                  <v-list-tile v-if="Rapor.DekontPusula==2" @click="secilibiletlereDekontBasdialog()">
                    <v-list-tile-title> {{ $t('Print-Note-Expenses-Selected-Tickets') }} </v-list-tile-title>
                  </v-list-tile>

                   <v-list-tile @click="secilibiletlereDekontYazdırdialog()">
                    <v-list-tile-title> {{ $t('Download-Receipt-Note-Html-Selected-Tickets') }} </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="seciliBiletlereCreditNoteOlustur(1, kayitadet, siralamatipi, false)" v-if="Rapor.IsCreditNoteCreated==3">
                    <v-list-tile-title> {{ $t('Seçili İadeler İçin Credit Note Oluştur') }} </v-list-tile-title>
                  </v-list-tile>

                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>


          <v-container fluid>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BaslangicTarihi" v-model="Rapor.BaslangicTarihi"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BitisTarihi" v-model="Rapor.BitisTarihi"></tarihcomp>
                      </v-flex>


                      <v-flex xs12 sm3 md1>
                        <v-layout align-end >
                          <v-radio-group  v-model="Rapor.DekontPusula">
                            <v-radio :label="$t('Receipt')" :value="1"></v-radio>
                            <v-radio :label="$t('Note-of-Expenses')" :value="2"></v-radio>

                          </v-radio-group>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
  <v-card flat color="grey lighten-5" class="pa-2" style="border:1px solid #e0e0e0; border-radius:8px;">
    <v-switch
      v-model="dekonttaTarihBasilmasin"
      color="info"
      hide-details
      :label="$t('Do-Not-Print-Dates-on-Receipt')"
    ></v-switch>

    <div class="caption grey--text">
      {{ $t('Do-Not-Print-Dates-on-Receipt-Description') }}
    </div>
  </v-card>
</v-flex>

<v-flex xs12 sm3 md2 v-if="sovos==true">
  <v-layout align-end>
    <v-radio-group v-model="Rapor.IsCreditNoteCreated">
      <v-radio :label="$t('All')" :value="0"></v-radio>
      <v-radio :label="$t('Credit-Note-can-be-generated.')" :value="3"></v-radio>
      <v-radio :label="$t('Credit-Note-Created.')" :value="1"></v-radio>
      <v-radio :label="$t('Credit-Note-Not-Created.')" :value="2"></v-radio>
    </v-radio-group>
  </v-layout>
</v-flex>
                      <v-flex pt-2>
                        <v-layout align-center="">
                          <div v-if="load1">
                            <v-btn color="info" @click="getList(1,kayitadet,siralamatipi,true)" fab small="" dark>

                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout align-center="">
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">
                                check_circle_outline </v-icon>
                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                              <span>{{ $t('Add-Search-Filter') }}</span>
                            </v-tooltip>



                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-layout row="" wrap v-if="listegorunum">

                  <v-flex v-show="kayitvarmi" xs12 sm12 md12>
                    <v-card flat="" color="grey lighten-5">
                      <v-flex xs12 sm12 md12>
                        <v-layout row wrap>

                          <v-flex xs12 sm2 md2>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-layout v-if="kayitvarmi" justify-center="" align-center>
                                  <v-checkbox v-model="tumunuseckaldir" :label="$t('Choose-All')"></v-checkbox>

                                </v-layout>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-flex>

                          <v-flex xs12 sm7 md7>
                            <v-layout align-center="" justify-center fill-height="">
                              <div class=" font-weight-large grey--text body-1">
                                <span class="red--text"> ({{sayfalama}}.{{this.$t('Page')}})</span> -  {{totalcount}} {{this.$t('number-records-listed')}}
                              </div>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm12 md2>
                            <v-select hide-details="" :items="siralamatipiitems" color="grey darken-1"
                              v-model="siralamatipi" item-text="text" item-value="value" :label="$t('Sort-By')">
                            </v-select>
                          </v-flex>
                          <v-flex v-show="kayitvarmi" xs12 sm12 md1>
                            <v-select hide-details="" :items="kayitsayisi" color="grey darken-1" v-model="kayitadet"
                              item-text="text" item-value="value" :label="this.$t('Show')"></v-select>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex pa-2 v-for="item in iadelist" v-bind:key="item.id" xs12 sm12 md12>

                        <v-card width="100%">
                          <v-list two-line="">
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-card flat class="black--text">
                                  <v-card flat="">
                                    <v-card-actions>
                                      <v-layout row wrap>
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-layout justify-center="" align-center>
                                              <v-checkbox hide-details="" v-model="secilenkayitlar"
                                                :value="item.itemcheck">
                                              </v-checkbox>
                                            </v-layout>
                                          </v-list-tile-content>
                                        </v-list-tile>

                                        <v-flex sm12 md1>
                                          <v-card flat="">
                                            <v-list-tile>
                                              <v-list-tile-content>
                                                <v-img :src="getImgUrl(item.GenelBilgileri.HavaYoluKodu)" height="80%"
                                                  width="80%" contain>
                                                </v-img>
                                              </v-list-tile-content>
                                            </v-list-tile>
                                          </v-card>
                                        </v-flex>

                                        <v-flex xs12 sm4 md2>
                                          <v-layout align-start justify-start row fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>
                                                  <v-layout row align-center justify-start>
                                                    <v-chip color="red" text-color="white">
                                                      {{ $t('Returned-Tickets') }} 
                                                    </v-chip>


                                                  </v-layout>
                                                  <v-list-tile-sub-title>
                                                    &nbsp;<span class='grey-text--primary caption '>
                                                      {{item.GenelBilgileri.HavaYoluKodu}}
                                                      -
                                                      {{item.GenelBilgileri.BiletNo}}
                                                      -
                                                      {{item.GenelBilgileri.UcusTip}}
                                                    </span>
                                                  </v-list-tile-sub-title>

                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>


                                        <v-flex xs12 sm4 md2>
                                          <v-layout align-start justify-start row fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>
                                                  <v-layout row wrap align-center="" justify-center>
                                                    <v-list-tile-title>
                                                      <div class="font-weight-large red--text title">
                                                        {{item.TarihBilgileri.IadeTarihi | dateformat}}
                                                      </div>
                                                    </v-list-tile-title>


                                                    <v-list-tile-sub-title>
                                                      <div class="font-weight-thin grey--text body-1 ">

                                                        Kod: {{item.GenelBilgileri.Cari.Kod}}

                                                      </div>
                                                      <div class="font-weight-thin grey--text body-1 ">

                                                        Unvan: {{item.GenelBilgileri.Cari.Unvan}}

                                                      </div>
                                                    </v-list-tile-sub-title>
                                                  </v-layout>
                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>


                                        <v-flex xs12 sm4 md2>
                                          <v-layout align-start justify-start row fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>
                                                  <v-layout row wrap align-center="" full-width justify-start>
                                                    <v-list-tile-sub-title
                                                      v-if="item.FaturaBilgileri.DekontNo!=0 && item.FaturaBilgileri.DekontNo!=null">

                                                      <v-chip v-if="Rapor.DekontPusula==1" color="green" small outline
                                                        label text-color="green">
                                                        <v-icon color="green" left>done</v-icon>
                                                        {{ $t('Receipt-No-v2') }} : {{item.FaturaBilgileri.DekontNo }}
                                                      </v-chip>
                                                      <v-chip v-if="Rapor.DekontPusula==2" color="green" small outline
                                                        label text-color="green">
                                                        <v-icon color="green" left>done</v-icon>
                                                        {{ $t('Note-of-Expenses-No') }} : {{item.FaturaBilgileri.DekontNo }}
                                                      </v-chip>



                                                    </v-list-tile-sub-title>
                                                    <v-list-tile-sub-title
                                                      v-if="item.FaturaBilgileri.DekontNo==0 && Rapor.DekontPusula==1">
                                                      <v-chip color="red" small outline label text-color="red">
                                                        <v-icon color="red" left>cancel</v-icon>
                                                        {{ $t('Receipt-Not-Printed') }}
                                                      </v-chip>
                                                    </v-list-tile-sub-title>
                                                    <v-list-tile-sub-title
                                                      v-if="item.FaturaBilgileri.DekontNo==0 && Rapor.DekontPusula==2">
                                                      <v-chip color="red" small outline label text-color="red">
                                                        <v-icon color="red" left>cancel</v-icon>
                                                        {{ $t('Note-Not-Printed') }}
                                                      </v-chip>
                                                    </v-list-tile-sub-title>

                                                    <v-list-tile-sub-title>
                                                      <div class="font-weight-large grey--text caption ">
                                                        {{ $t('Returns-Invoice-No') }}
                                                        :<span
                                                          class="font-weight-large grey--text caption">
                                                          {{item.FaturaBilgileri.IadeFaturaNo}}
                                                        </span>
                                                      </div>
                                                    </v-list-tile-sub-title>

                                                    <v-list-tile-sub-title>
                                                      <div class="font-weight-large grey--text caption ">
                                                        {{ $t('Incoming-Document-No') }}
                                                        :<span
                                                          class="font-weight-large grey--text caption">
                                                          {{item.FaturaBilgileri.IadeFaturaGelenBelgeNo}}
                                                        </span>
                                                      </div>
                                                    </v-list-tile-sub-title>
                                                  </v-layout>
                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex class="hidden-md-and-up" xs2 sm2 md2>
                                        </v-flex>

                                        <v-flex xs12 sm4 md2>
                                          <v-layout>

                                            <v-flex xs12 sm6 md6>
                                              <v-layout align-start="" justify-start fill-height>
                                                <v-card flat="">
                                                  <v-list-tile>
                                                    <v-list-tile-content>
                                                      <v-list-tile-sub-title>
                                                        <div class="font-weight caption ">
                                                          {{ $t('Ticket-Amount') }}:
                                                        </div>
                                                      </v-list-tile-sub-title>
                                                      <v-list-tile-sub-title>
                                                        <div class="font-weight caption ">
                                                          {{ $t('Penalty-Amount') }} :
                                                        </div>
                                                      </v-list-tile-sub-title>
                                                      <v-list-tile-sub-title>
                                                        <div class="font-weight caption ">
                                                          &nbsp;
                                                        </div>
                                                      </v-list-tile-sub-title>
                                                      <v-list-tile-sub-title>
                                                        <div class="font-weight caption ">

                                                        </div>
                                                      </v-list-tile-sub-title>

                                                    </v-list-tile-content>
                                                  </v-list-tile>
                                                </v-card>
                                              </v-layout>
                                            </v-flex>

                                            <v-flex xs12 sm6 md6>
                                              <v-layout row justify-end="" fill-height>
                                                <v-card flat="">
                                                  <v-list-tile>
                                                    <v-list-tile-content>
                                                      <v-list-tile-sub-title>
                                                        <v-layout align-center="" justify-end>
                                                          <div class="font-weight caption ">
                                                            {{item.TutarBilgileri.Tutar.Tutar | moneyformat}}{{getparabirimi()}}
                                                          </div>
                                                        </v-layout>
                                                      </v-list-tile-sub-title>
                                                      <v-list-tile-sub-title>
                                                        <v-layout align-center="" justify-end="">
                                                          <div class="font-weight caption ">
                                                            {{item.TutarBilgileri.CezaTutar.CezaTutar  | moneyformat}}{{getparabirimi()}}

                                                          </div>
                                                        </v-layout>
                                                      </v-list-tile-sub-title>
                                                      <v-list-tile-sub-title>
                                                        <v-layout align-center="" justify-end="">
                                                          <div class="font-weight caption ">
                                                            &nbsp;
                                                          </div>
                                                        </v-layout>
                                                      </v-list-tile-sub-title>
                                                      <v-list-tile-sub-title>
                                                        <v-layout align-center="">
                                                          <div class="font-weight caption ">

                                                          </div>
                                                        </v-layout>
                                                      </v-list-tile-sub-title>
                                                    </v-list-tile-content>
                                                  </v-list-tile>
                                                </v-card>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm4 md1>
                                          <v-layout row align-center justify-center="" fill-height="">
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>
                                                  <v-layout row wrap justify-center="">
                                                    <v-list-tile-title>
                                                      <v-layout row wrap justify-center="">
                                                        {{$t('Net-Amount')}}
                                                      </v-layout>
                                                    </v-list-tile-title>
                                                    <v-list-tile-sub-title>
                                                      <v-layout row wrap justify-center="">
                                                        <div class="red--text title">
                                                          {{item.TutarBilgileri.NetTutar.NetTutar | moneyformat}}{{getparabirimi()}}
                                                        </div>
                                                      </v-layout>

                                                    </v-list-tile-sub-title>

                                                  </v-layout>
                                                </v-list-tile-content>

                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex sm4 md1>
                                          <v-layout row align-center justify-center="">
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-action>
                                                  <v-layout align-center="" row fill-height="" justify-center>
                                                    <v-menu
  v-if="item.FaturaBilgileri.DekontNo != 0 && item.FaturaBilgileri.DekontNo != null"
  offset-y
  bottom
>
  <v-btn
    slot="activator"
    color="info"
    outline
    small
    :loading="pdfLoading"
    :disabled="pdfLoading"
  >
    <v-icon left small>file_download</v-icon>
    İndir
    <v-icon right small>arrow_drop_down</v-icon>
  </v-btn>

  <v-list>
    <v-list-tile @click="DekontYazdir(item)">
      <v-list-tile-action>
        <v-icon color="grey">description</v-icon>
      </v-list-tile-action>
      <v-list-tile-title>HTML</v-list-tile-title>
    </v-list-tile>

    <v-list-tile @click="DekontPdfIndir(item)">
      <v-list-tile-action>
        <v-icon color="red">picture_as_pdf</v-icon>
      </v-list-tile-action>
      <v-list-tile-title>PDF</v-list-tile-title>
    </v-list-tile>
  </v-list>
</v-menu>

                                                    <v-btn color="info" outline
                                                      v-if="(item.FaturaBilgileri.DekontNo==0 || item.FaturaBilgileri.DekontNo==null) && Rapor.DekontPusula==1 "
                                                      @click="tekbiletlereDekontBasdialog(item.itemcheck)"> {{ $t('Print-Receipt') }}

                                                    </v-btn>

                                                    <v-btn color="info" outline
                                                      v-if="(item.FaturaBilgileri.DekontNo==0 || item.FaturaBilgileri.DekontNo==null) && Rapor.DekontPusula==2 "
                                                      @click="tekbiletlereDekontBasdialog(item.itemcheck)"> {{ $t('Print-Note') }}

                                                    </v-btn>


                                                  </v-layout>
                                                </v-list-tile-action>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-actions>
                                  </v-card>
                                </v-card>
                              </v-flex>
                            </v-layout>
                          </v-list>
                        </v-card>
                      </v-flex>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-form>
          </v-container>


          <v-container v-if="kayitvarmi" fluid="">

            <v-flex xs12 sm12 md12>
              <v-layout row fill-height="" justify-center>
                <v-pagination v-model="sayfalama" :length="pagenumber"></v-pagination>
              </v-layout>
            </v-flex>

          </v-container>


          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">


                  <v-flex xs12 sm12 md12>
                    <v-card flat class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">

                            <v-flex xs12 sm12 md12>
                              <havayollaricomp :etiket="$t('Airline-Code')" v-model="havayolubil"></havayollaricomp>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-text-field hide-details="" ref="ara" v-model="Rapor.BiletNo" mask="##########"
                                :label="$t('Ticket-No')">
                              </v-text-field>

                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-text-field hide-details="" v-model="Rapor.YolcuAdi" :label="$t('Name-of-Passenger')">
                              </v-text-field>

                            </v-flex>


                            <v-flex xs12 sm12 md12>
                              <v-text-field hide-details="" v-model="Rapor.DekontNo" :label="$t('Receipt-No-v2')">
                              </v-text-field>

                            </v-flex>
                            <v-flex xs12 sm12 md12>

                              <cariaracomp v-bind:etiket="$t('Currentcode_label')" :loading="loading" v-bind:value="Rapor.CariKodu" v-model="Rapor.CariKodu"></cariaracomp>
                        
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-radio-group hide-details v-model="Rapor.DekontBas">
                                <v-radio :label="$t('all_records')" :value="0"></v-radio>
                                <v-radio :label="$t('Receipt-Note-Printed')" :value="1"></v-radio>
                                <v-radio :label="$t('Receipt-Note-Not-Printed')" :value="2"></v-radio>
                              </v-radio-group>

                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-radio-group hide-details :label="$t('Line-Type')" v-model="Rapor.HatTipi">
                                <v-radio :label="$t('All')" :value="0"></v-radio>
                                <v-radio :label="$t('Domestic-Line')" :value="1"></v-radio>
                                <v-radio :label="$t('International-Line')" :value="2"></v-radio>
                              </v-radio-group>

                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>

                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import logoo from '../../../assets/control'
  import onaydialog from "@/components/app/customcomp/onaydialog.vue"
  import loadingcomp from "@/components/app/customcomp/loadingcomp"

  import helpers from "@/components/app/customcomp/helpers.js"
  import parainput from "@/components/app/customcomp/parainput.vue"
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'

  export default {
    data() {
      return {
        dialogsonucv2:false,
pdfLoading: false,

// Varsayılan true: mevcut davranış bozulmasın, tarih basılsın
dekonttaTarihBasilmasin: false,

headerscreditnotesonuc: [
  {
    text: 'CreditNoteNumber',
    value: 'CreditNoteNumber',
    sortable: false
  },
  {
    text: 'InvoiceReference',
    value: 'InvoiceReference',
    sortable: false
  },
  {
    text: this.$t('Result'),
    sortable: false
  },
  {
    text: 'Mesaj',
    sortable: false
  }
],
        CreateCreditNoteResult:true,
        creditnotesreturn:[],
        creditnotemesaj:'',
      sovos:false,
        loading: false,
        statecari: [],
        searchcari: '',
        loadingvmodel: false,
        BaslangicDekontNo: null,
        dekontdurum: false,
        dialogsor: false,
        valid2: true,
        tumunuseckaldir: false,
        secilenkayitlar: [],
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        sayfalama: 1,
        pagenumber: 1,
        listegorunum: true,
        recordcount: null,
        kayitvarmi: false,
        kayitadet: 50,
        iadelist: [],
        siralamatipi: 'RefundDate',

    
        kayitsayisivmodel: 50,
        kayitsayisi: [{
          text: '50',
          value: 50
        }, {
          text: '100',
          value: 100
        }],

        totalcount: 0,

        havayolubil: {
          havayolukodu: null,
          formno: null
        },
        ToplamAdet: 0,
        GenelDipToplam: 0,
        search: '',
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,
        Rapor: {
          IsCreditNoteCreated:0,
          HavaYoluKodu: null,
          BiletNo: null,
          CariKodu: null,
          FormNo: null,
          SirketKodu: null,
          Sirano: null,
          BaslangicTarihi: null,
          BitisTarihi: null,
          DekontBas: 0,
          DekontPusula: 1,
          HatTipi: 0, // 0: Hepsi, 1: İç Hat, 2: Dış Hat
          DekontNo: null,
          YolcuAdi: null,
          Paging: {
            SayfaNo: 1,
            VeriAdet: 50,
            SiralamaTip: 'RefundDate',
          }
        },

        hesapgurubu: [],
        masrafmerkezi: [],
        doviztipi: [],
        valid: true,
        tumsirketler: '',
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemsbs: [],
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
    try
        {
 this.sovos=JSON.parse(window.localStorage.getItem('sovos'));
        }
        catch{
console.log('sovos okunamadı');
        }
   
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status != true) {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var mainUrl = '#/'
              window.open(mainUrl, '_self')
            }
          } 

        });
      } 
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      parainput,
      havayollaricomp,
      yetkidialog,
      onaydialog,
      loadingcomp,
      cariaracomp
    },
    watch: {
      'siralamatipi': function (valuetip) {
        this.getList(this.sayfalama, this.kayitadet, valuetip, false)
      },
      'kayitadet': function (valueveriadet) {
        this.getList(1, valueveriadet, this.siralamatipi, false)
        this.sayfalama = 1
      },
      'Rapor.DekontPusula': function (val) {
        this.getList(1, this.kayitadet, this.siralamatipi, true);
      },
      'Rapor.IsCreditNoteCreated': function (val) {
        this.getList(1, this.kayitadet, this.siralamatipi, false);
      },
      'tumunuseckaldir': function (value) {

        if (value == true) {

          this.getListtumu();

        } else {
          this.secilenkayitlar = []
        }
      },
      sayfalama(value) {
        this.getList(value, this.kayitadet, this.siralamatipi, false)
      },
    },
    methods: {
      dialogsonuciptalv2(){
        this.secilenkayitlar = [];
this.dialogsonucv2=false;
this.getList(1, this.kayitadet, this.siralamatipi, false);
      },
      getparabirimi() {
        return helpers.getparabirimi()
      },
      getDekontPusula() {
        if (this.Rapor.DekontPusula == 1) {
          return 'D'
        } else if (this.Rapor.DekontPusula == 2) {
          return 'P'
        } else {
          return null
        }
      },
      tekbiletlereDekontBasdialog(item) {

        this.secilenkayitlar = []

        var drm = true

        this.secilenkayitlar.push(item)

        this.secilenkayitlar.forEach(element => {
          if (element.DekontDurumu == true) {
            drm = false
          }
        });

        if (drm === true) {

          this.$refs.onaydialog.open(this.$t('Are-you-sure-want-transaction'), 1).then(sonuc => {

            if (sonuc == true) {
              this.secilibiletlereDekontBas();
            }
          });

        } else {
          this.text1 = this.$t('choose-records-printed-receipts-notes')
          this.snackbar = true
        }


      },

      secilibiletlereDekontYazdırdialog() {
        if (this.secilenkayitlar.length > 0) {
            for(let i = 0; i < this.secilenkayitlar.length; i++) {
              setTimeout(function() {
               if (this.secilenkayitlar[i].DekontDurumu == true) {
                     this.CokluDekontYazdir(this.secilenkayitlar[i]);
                }
                else{
                  this.text1 = this.$t('printed-Receipt-Note-detected-among-chosen-tickets')
                  this.snackbar = true
                  this.dialogsor = false
                }
               
              }.apply(this), i * 1000);
          }
        } else {
          this.text1 = this.$t('Please-choose-records')
          this.snackbar = true
          this.dialogsor = false
        }
      },
      seciliBiletlereCreditNoteOlustur(sayfano, adet, siralatip, arama){

  if (this.secilenkayitlar.length > 0) {

          var drm = true

          this.secilenkayitlar.forEach(element => {
            if (element.DekontDurumu == true) {
              drm = false
            }
          });


       

        } else {
          this.text1 = this.$t('Please-choose-records')
          this.snackbar = true
          this.dialogsor = false
          return;
        }
      
var params2 = {
          IadeList: this.secilenkayitlar
        }

  if (this.$refs.formgunluksatis.validate()) {
      this.loadingvmodel = true


      if (arama == true) {
        this.secilenkayitlar = []
        this.tumunuseckaldir = false
      }


      this.kayitvarmi = false
      var bastarih = new Date(this.Rapor.BaslangicTarihi)
      var bittarih = new Date(this.Rapor.BitisTarihi)

      if (bastarih <= bittarih) {

        this.load1 = false
        this.iadelist = []

        this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        this.Rapor.Paging.SayfaNo = sayfano
        this.Rapor.Paging.VeriAdet = adet
        this.Rapor.Paging.SiralamaTip = siralatip
        this.creditnotesreturn=[];
        var params = this.Rapor
        params.DekontNoInputObjForCreditNote=params2;

        this.$http.post(auth.API_URL + 'api/Ticket/CreateAutoCreditNoteForIade', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
           this.CreateCreditNoteResult=response.body.Status;
           if (response.body.Status == true) {
           
           this.loadingvmodel = false
            this.creditnotemesaj=response.body.ResponseMessage;
            this.creditnotesreturn=response.body.returns;
            this.dialogsonucv2=true;

            
          } else {
           this.loadingvmodel = false
            this.creditnotemesaj=response.body.ResponseMessage;
            this.creditnotesreturn=response.body.returns;
            this.dialogsonucv2=true;
          }
           
         
        }, (response) => {
          
            this.text1 = 'Service Unavailable-CreateCreditNote'
            this.snackbar = true
           this.loadingvmodel = false
        })
       
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
        this.loadingvmodel = false
      }
    }
      },
      secilibiletlereDekontBasdialog() {
        if (this.secilenkayitlar.length > 0) {

          var drm = true

          this.secilenkayitlar.forEach(element => {
            if (element.DekontDurumu == true) {
              drm = false
            }
          });


          if (drm === true) {


            this.$refs.onaydialog.open('İşleminizi onaylıyor musunuz?', 1).then(sonuc => {

              if (sonuc == true) {
                this.secilibiletlereDekontBas();
              }
            });



          } else {
            this.text1 = this.$t('choose-records-printed-receipts-notes')
            this.snackbar = true
          }

        } else {
          this.text1 = this.$t('Please-choose-records')
          this.snackbar = true
          this.dialogsor = false
        }
      },

      secilibiletlereDekontBas() {


        this.loadingvmodel = true
        this.load1 = false

        var params = {
          IadeList: this.secilenkayitlar
        }

        this.$http.post(auth.API_URL + "api/Ticket/RefundReceiptNoSave", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then((response) => {

           this.text1 = this.$t(response.body.ResponseMessage);
          this.snackbar = true;

          if (response.body.Status == true) {

            this.getList(1, this.kayitadet, this.siralamatipi, true)
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.loadingvmodel = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.loadingvmodel = false
            this.load1 = true
          }
        })

      },

      getImgUrl(img) {
        return logoo.logoControl(img);
      },
      git(v) {


        var url = '#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + v.GenelBilgileri.HavayoluKodu + '&biletno=' + v
          .GenelBilgileri
          .BiletNo + '&ucustipi=' + v.GenelBilgileri.UcusTip
        window.open(url, '_blank')
      },
      getList: getList,
      getListtumu: getListtumu,
      DekontYazdir: DekontYazdir,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      CokluDekontYazdir:CokluDekontYazdir,
      DekontPdfIndir:DekontPdfIndir
    },
    computed:{
        siralamatipiitems(){
          return [{
          text: this.$t('Date-Ascending'),
          value: 'RefundDate'
        }, {
          text: this.$t('Date-Descending'),
          value: 'RefundDateDesc'
        }, {
          text: this.$t('Current-Ascending'),
          value: 'RefundCurrentCode'
        }, {
          text: this.$t('Current-Descending'),
          value: 'RefundCurrentCodeDesc'
        }, {
          text: this.$t('Invoice-Date-Ascending'),
          value: 'RefundInvoiceDate'
        }, {
          text: this.$t('Invoice-Date-Descending'),
          value: 'RefundInvoiceDateDesc'
        }, {
          text: this.$t('Price-Ascending'),
          value: 'RefundAmount'
        }, {
          text: this.$t('Price-Descending'),
          value: 'RefundAmountDesc'
        }, {
          text: this.$t('Returns-Ticket-No-Ascending'),
          value: 'RefundTicket'
        }, {
          text: this.$t('Returns-Ticket No-Descending'),
          value: 'RefundTicketDesc'
        }, {
          text: this.$t('Receipt-No-Ascending'),
          value: 'RefundReceipt'
        }, {
          text: this.$t('Receipt-No-Descending'),
          value: 'RefundReceiptDesc'
        }]
        },

        headersbs(){
        return [{
            text: this.$t('Code'),
            value: 'CariKod',
          },
          {
            text: this.$t('Ticket-No'),
            value: 'GenelBilgileri.BiletNo ',
          },
          {
            text: 'HY Kod',
            value: 'GenelBilgileri.HavayoluKodu',
          },
          {
            text: this.$t('Internal-External'),
            value: 'GenelBilgileri.UcusTipi',
          },
          {
            text: this.$t('Name-of-Passenger'),
            value: 'YolcuAdi',
          },
          {
            text: this.$t('Cancellation-Date'),
            value: 'TarihBilgi.IptalTarihi',
          },
          {
            text: this.$t('Sales-Date'),
            value: 'TarihBilgi.SatisTarihi',
          },
          {
            text: this.$t('Date-of-Ticket-Issue'),
            value: 'TarihBilgi.KesimTarihi',
          },
          {
            text: this.$t('Amount'),
            value: 'BiletTutar',
          },
          {
            text: this.$t('Tax-v2'),
            value: 'VergiTutar',
          },
          {
            text: this.$t('Discount'),
            value: 'IskontoTutar',
          }
        ]
        },
    }
  }


  function filtrele() {
    this.dialogfiltre = true

  }

  function filtrekayit() {
    this.filtrevarmi = true
    this.dialogfiltre = false
    this.sayfalama = 1
    this.getList(1, this.kayitadet, this.siralamatipi, true)
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false
    this.havayolubil.havayolukodu = null
    this.Rapor.YolcuAdi = null
    this.Rapor.DekontNo = null
    this.Rapor.CariKodu = null
    this.Rapor.HavaYoluKodu = null
    this.Rapor.BiletNo = null
    this.Rapor.DekontBas = 0
    this.Rapor.HatTipi = 0
    this.tumsirketler = false
    this.getList(1, this.kayitadet, this.siralamatipi, true)
    this.sayfalama = 1

  }


  function getList(sayfano, adet, siralatip, arama) {



    if (this.$refs.formgunluksatis.validate()) {
      this.loadingvmodel = true


      if (arama == true) {
        this.secilenkayitlar = []
        this.tumunuseckaldir = false
      }


      this.kayitvarmi = false
      var bastarih = new Date(this.Rapor.BaslangicTarihi)
      var bittarih = new Date(this.Rapor.BitisTarihi)

      if (bastarih <= bittarih) {

        this.load1 = false
        this.iadelist = []

        this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        this.Rapor.Paging.SayfaNo = sayfano
        this.Rapor.Paging.VeriAdet = adet
        this.Rapor.Paging.SiralamaTip = siralatip

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/Ticket/RefundList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.length > 0) {
            this.kayitvarmi = true
            this.loadingvmodel = false
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var yenilist = [];

            response.body.forEach(element => {
              var dekontdurumu = false
              if (element.FaturaBilgileri.DekontNo != 0 && element.FaturaBilgileri.DekontNo != null) {
                dekontdurumu = true
              }



              var itemdegeri = {
                SirketKodu: credentials.SirketKodu,
                HavaYoluKodu: element.GenelBilgileri.HavaYoluKodu,
                FormNo: element.GenelBilgileri.Formno,
                BiletNo: element.GenelBilgileri.BiletNo,
                Sirano: element.GenelBilgileri.Sirano,
                IadeTarihi: element.TarihBilgileri.IadeTarihi,
                BiletShow: true,
                DekontPusula: this.getDekontPusula(),
                DekontDurumu: dekontdurumu
              }

              var a = {
                BiletBilgileri: element.BiletBilgileri,
                DigerBilgileri: element.DigerBilgileri,
                FaturaBilgileri: element.FaturaBilgileri,
                GenelBilgileri: element.GenelBilgileri,
                LoginBilgileri: element.LoginBilgileri,
                OdemeBilgileri: element.OdemeBilgileri,
                TarihBilgileri: element.TarihBilgileri,
                TutarBilgileri: element.TutarBilgileri,
                itemcheck: itemdegeri
              }
              yenilist.push(a)
            });



            this.iadelist = yenilist
            if (this.Rapor.DekontBas == 2) {
              this.dekontdurum = true
            } else {
              this.dekontdurum = false
            }
            this.totalcount = response.body[0].TotalCount
            this.pagenumber = response.body[0].TotalPage
            this.recordcount = response.body.length

          } else {
            this.kayitvarmi = false
            this.dekontdurum = false
          }

          this.loadingvmodel = false
          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.kayitvarmi = false
            this.progress = false
            this.loadingvmodel = false
            this.dekontdurum = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.dekontdurum = false
            this.loadingvmodel = false
            this.kayitvarmi = false
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }


  }

  function getListtumu() {

    if (this.$refs.formgunluksatis.validate()) {

      this.secilenkayitlar = []

      var bastarih = new Date(this.Rapor.BaslangicTarihi)
      var bittarih = new Date(this.Rapor.BitisTarihi)

      if (bastarih <= bittarih) {


        this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        this.Rapor.Paging.SayfaNo = null
        this.Rapor.Paging.VeriAdet = null
        this.Rapor.Paging.SiralamaTip = this.siralamatipi

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/Ticket/RefundList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (response.body.length > 0) {


            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            this.secilenkayitlar = [];
            response.body.forEach(element => {

              var dekontdurumu = false



              if (element.FaturaBilgileri.DekontNo != 0 && element.FaturaBilgileri.DekontNo != null) {
                dekontdurumu = true
              }

              var itemdegeri = {
                SirketKodu: credentials.SirketKodu,
                HavaYoluKodu: element.GenelBilgileri.HavaYoluKodu,
                FormNo: element.GenelBilgileri.Formno,
                BiletNo: element.GenelBilgileri.BiletNo,
                Sirano: element.GenelBilgileri.Sirano,
                IadeTarihi: element.TarihBilgileri.IadeTarihi,
                BiletShow: true,
                DekontPusula: this.getDekontPusula(),
                DekontDurumu: dekontdurumu
              }

              this.secilenkayitlar.push(itemdegeri);
            });


          }



        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }


  }

    function CokluDekontYazdir(val) {
    this.progress = true
    this.load1 = false

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var lang = localStorage.getItem('lang');
var params = {
  SirketKodu: credentials.SirketKodu,
  HavaYoluKodu: val.HavaYoluKodu,
  FormNo: val.FormNo,
  BiletNo: val.BiletNo,
  Sirano: val.Sirano,
  IadeTarihi: val.IadeTarihi,

  // Toplu HTML çıktıda da aynı seçim geçerli
IadeTarihiBasilsin: !this.dekonttaTarihBasilmasin,


  BiletShow: true
}
    this.$http.post(auth.API_URL + "api/Ticket/RefundReceiptReportHtml", params, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader()
      }
    }).then((response) => {
      this.progress = false
      this.load1 = true
          if (lang=='en')
          {
            
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> İADE DEKONT FORMU </title>','<title> REFUND RECEIPT FORM </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>İADE DEKONT FORMU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>REFUND RECEIPT FORM</font>")
             bodyhtml=bodyhtml.toString().replace("Dekont Tarihi :","Receipt Date :")
             bodyhtml=bodyhtml.toString().replace("Dekont No :","Receipt No :")
             bodyhtml=bodyhtml.toString().replace("Muhasebe Code :","Accounting Code :")
             bodyhtml=bodyhtml.toString().replace("Unvani","Title")
             bodyhtml=bodyhtml.toString().replace("Adres","Address")
             bodyhtml=bodyhtml.toString().replace("İl - İlçe :","City - District:")
             bodyhtml=bodyhtml.toString().replace("Fatura No","Invoice No")
             bodyhtml=bodyhtml.toString().replace("Parkur","Route")
             bodyhtml=bodyhtml.toString().replace("Kdv %20 Matrah:","VAT 20% Base:")
             bodyhtml=bodyhtml.toString().replace("Kdv %10 Matrah:","VAT 10% Base:")
             bodyhtml=bodyhtml.toString().replace("Kdv %0 Matrah:","VAT 0% Base:")
             bodyhtml=bodyhtml.toString().replace("Kesen Kişi :","Made by:")
             bodyhtml=bodyhtml.toString().replace("Tutar :","Amount :")
             bodyhtml=bodyhtml.toString().replace("İskonto :","Discount :")
             bodyhtml=bodyhtml.toString().replace("Diğer :","Other :")
             bodyhtml=bodyhtml.toString().replace("Alan :","Area :")
             bodyhtml=bodyhtml.toString().replace("Rezervasyon Veren :"," Reservation Provider:")
             bodyhtml=bodyhtml.toString().replace("Maturity Tarihi :","Maturity Date :")
             bodyhtml=bodyhtml.toString().replace("Bilet No","Ticket No")
             bodyhtml=bodyhtml.toString().replace('Bilet iadeleri ve ilgili faturalarının KDV kanununun 10.Maddesi ve VUK.231 maddesinin 5.fıkrasi geregi 7 gun icerisinde duzenlenmesi gerekir.','')
             bodyhtml=bodyhtml.toString().replace(" TRY KDV toplam bilet bedeline dahildir."," ")
             bodyhtml=bodyhtml.toString().replace("<font face = 'Tahoma' size = '1' color = 'black'>Yalnız"," <font face = 'Tahoma' size = '1' color = 'black' hidden>Yalnız")
              bodyhtml=bodyhtml.toString().replace("<td colspan='7' width = '800' align = left bgcolor = 'DBDBDB' style = 'border:solid windowtext 1.0pt' ><font face = 'Tahoma' size = '1' color = 'black'>Yalnız","<td hidden colspan='7' width = '800' align = left bgcolor = 'DBDBDB' style = 'border:solid windowtext 1.0pt' ><font face = 'Tahoma' size = '1' color = 'black'>Yalnız")
              bodyhtml=bodyhtml.toString().replace("Yolcu Name","Passenger Name")  
            
             console.log(bodyhtml);
             response.bodyText=bodyhtml;
             
          }
      var blob = new Blob([response.bodyText], {
        type: 'application/html'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      if(this.Rapor.DekontPusula == 2){
        link.download = "GiderPusulasi-"+ val.BiletNo +".html";
      }else{
        link.download = "Receipt-"+ val.BiletNo +".html"
      }
      link.click();
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true
      }
    })
  }

  function DekontPdfIndir(val) {
  if (val.FaturaBilgileri.DekontNo == 0 || val.FaturaBilgileri.DekontNo == null) {
    this.text1 = this.$t('Receipt-Note-Not-Printed');
    this.snackbar = true;
    return;
  }

  this.pdfLoading = true;

  var credentials = JSON.parse(window.localStorage.getItem('credentials'));

 var params = {
  SirketKodu: credentials.SirketKodu,
  HavaYoluKodu: val.GenelBilgileri.HavaYoluKodu,
  FormNo: val.GenelBilgileri.Formno,
  BiletNo: val.GenelBilgileri.BiletNo,
  Sirano: val.GenelBilgileri.Sirano,
  IadeTarihi: val.TarihBilgileri.IadeTarihi,

  // Bu tarih kaydı bulmak için gitmeye devam edecek.
  // Sadece çıktıda basılıp basılmayacağını söylüyoruz.
IadeTarihiBasilsin: !this.dekonttaTarihBasilmasin,

  BiletShow: true
};

  this.$http.post(auth.API_URL + "api/Ticket/RefundReceiptReportPdf", params, {
    headers: {
      Authorization: "Bearer " + auth.getAuthHeader()
    },
    responseType: "arraybuffer"
  }).then((response) => {
    var blob = new Blob([response.data], {
      type: 'application/pdf'
    });

    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);

    if (this.Rapor.DekontPusula == 2) {
      link.download = "GiderPusulasi-" + val.GenelBilgileri.BiletNo + ".pdf";
    } else {
      link.download = "Dekont-" + val.GenelBilgileri.BiletNo + ".pdf";
    }

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);

    this.pdfLoading = false;
  }, (response) => {
    this.text1 = 'PDF indirilemedi';
    this.snackbar = true;
    this.pdfLoading = false;
  });
}

  function DekontYazdir(val) {


    this.progress = true
    this.load1 = false

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var lang = localStorage.getItem('lang');
var params = {
  SirketKodu: credentials.SirketKodu,
  HavaYoluKodu: val.GenelBilgileri.HavaYoluKodu,
  FormNo: val.GenelBilgileri.Formno,
  BiletNo: val.GenelBilgileri.BiletNo,
  Sirano: val.GenelBilgileri.Sirano,
  IadeTarihi: val.TarihBilgileri.IadeTarihi,

  // HTML çıktıda iade tarihi basılsın mı?
IadeTarihiBasilsin: !this.dekonttaTarihBasilmasin,

  BiletShow: true
}

    this.$http.post(auth.API_URL + "api/Ticket/RefundReceiptReportHtml", params, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader()
      }
    }).then((response) => {
      this.progress = false
      this.load1 = true
      if (lang=='en')
          {
            
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> İADE DEKONT FORMU </title>','<title> REFUND RECEIPT FORM </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>İADE DEKONT FORMU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>REFUND RECEIPT FORM</font>")
             bodyhtml=bodyhtml.toString().replace("Dekont Tarihi :","Receipt Date :")
             bodyhtml=bodyhtml.toString().replace("Dekont No :","Receipt No :")
             bodyhtml=bodyhtml.toString().replace("Muhasebe Code :","Accounting Code :")
             bodyhtml=bodyhtml.toString().replace("Unvani","Title")
             bodyhtml=bodyhtml.toString().replace("Adres","Address")
             bodyhtml=bodyhtml.toString().replace("İl - İlçe :","City - District:")
             bodyhtml=bodyhtml.toString().replace("Fatura No","Invoice No")
             bodyhtml=bodyhtml.toString().replace("Parkur","Route")
             bodyhtml=bodyhtml.toString().replace("Kdv %20 Matrah:","VAT 20% Base:")
             bodyhtml=bodyhtml.toString().replace("Kdv %10 Matrah:","VAT 10% Base:")
             bodyhtml=bodyhtml.toString().replace("Kdv %0 Matrah:","VAT 0% Base:")
             bodyhtml=bodyhtml.toString().replace("Kesen Kişi :","Made by:")
             bodyhtml=bodyhtml.toString().replace("Tutar :","Amount :")
             bodyhtml=bodyhtml.toString().replace("İskonto :","Discount :")
             bodyhtml=bodyhtml.toString().replace("Diğer :","Other :")
             bodyhtml=bodyhtml.toString().replace("Alan :","Area :")
             bodyhtml=bodyhtml.toString().replace("Rezervasyon Veren :"," Reservation Provider:")
             bodyhtml=bodyhtml.toString().replace("Maturity Tarihi :","Maturity Date :")
             bodyhtml=bodyhtml.toString().replace("Bilet No","Ticket No")
             bodyhtml=bodyhtml.toString().replace('Bilet iadeleri ve ilgili faturalarının KDV kanununun 10.Maddesi ve VUK.231 maddesinin 5.fıkrasi geregi 7 gun icerisinde duzenlenmesi gerekir.','')
             bodyhtml=bodyhtml.toString().replace(" TRY KDV toplam bilet bedeline dahildir."," Vat Amount included in the total ticket price")
             bodyhtml=bodyhtml.toString().replace("<font face = 'Tahoma' size = '1' color = 'black'>Yalnız"," <font face = 'Tahoma' size = '1' color = 'black' hidden>Yalnız")
              bodyhtml=bodyhtml.toString().replace("<td colspan='7' width = '800' align = left bgcolor = 'DBDBDB' style = 'border:solid windowtext 1.0pt' ><font face = 'Tahoma' size = '1' color = 'black'>Yalnız","<td hidden colspan='7' width = '800' align = left bgcolor = 'DBDBDB' style = 'border:solid windowtext 1.0pt' ><font face = 'Tahoma' size = '1' color = 'black'>Yalnız")
              bodyhtml=bodyhtml.toString().replace("Yolcu Name","Passenger Name")  
            
             console.log(bodyhtml);
             response.bodyText=bodyhtml;
             
          }
      var blob = new Blob([response.bodyText], {
        type: 'application/html'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      if(this.Rapor.DekontPusula == 2){
        link.download = "GiderPusulasi-"+ val.GenelBilgileri.BiletNo +".html";
      }else{
        link.download = "Receipt-"+ val.GenelBilgileri.BiletNo +".html"
      }
      link.click();
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true
      }
    })


  }

  function getListExcel() {

    if (this.$refs.formgunluksatis.validate()) {

      var bastarih = new Date(this.Rapor.BaslangicTarihi)
      var bittarih = new Date(this.Rapor.BitisTarihi)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + "api/Ticket/RefundListExcel", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "IadeListesi.xlsx";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }

  function beforeMount() {}
</script>
<style>
</style>